/* eslint-disable react/require-default-props */
import React from 'react';
import { Text } from '@ui';
import { Tag } from '@ui/atoms/Tag';
import { translate } from '@utils/i18n';
import { IssueStatusEnum } from '../../types';
import IssueLayout from './IssueLayout';
import './styles.scss';
/* eslint-disable @typescript-eslint/naming-convention */
const SIGNATURE_TYPE_LABELS = {
    inspector: 'Inspector Signature',
    client: 'Client Signature',
    correction: 'Correction Signature',
    installer: 'Installer Signature',
    authority: 'Authority Signature',
    building_owner: 'Building Owner Signature'
};
/* eslint-enable @typescript-eslint/naming-convention */
export default function SignatureQualityCheckCard({ issue, defaultExpanded, onToggle, onUpdateIssue, onUndoAction, readOnly = false }) {
    var _a;
    const { signatureType, reason, confidence, imageUrl } = issue.issueData;
    const status = issue.status || IssueStatusEnum.Detected;
    const handleSuggestCorrection = () => {
        onUpdateIssue(issue.id, status, true);
    };
    const handleDismissIssue = () => {
        onUpdateIssue(issue.id, IssueStatusEnum.DismissedByBackOffice, false);
    };
    const signatureLabel = (_a = SIGNATURE_TYPE_LABELS[signatureType]) !== null && _a !== void 0 ? _a : signatureType === null || signatureType === void 0 ? void 0 : signatureType.replace(/_/g, ' ');
    const confidencePct = confidence != null
        ? translate('confidence_pct', { namespace: 'features.iim_review.issue_card', pct: Math.round(confidence * 100) })
        : null;
    return (React.createElement(IssueLayout, { issueType: issue.issueType, status: status, defaultExpanded: defaultExpanded, onToggle: onToggle, onSuggestCorrection: handleSuggestCorrection, onDismissIssue: handleDismissIssue, onUndoAction: onUndoAction, readOnly: readOnly, statusChanges: issue.statusChanges, markedForSuggestion: issue.markedForSuggestion, hideSuggestCorrection: true },
        React.createElement("div", { className: "signature-quality-card" },
            signatureLabel && (React.createElement("div", { className: "signature-quality-card__context" },
                React.createElement(Text, { variant: "xx-small", as: "p", className: "signature-quality-card__context-label" }, translate('question_context_label', { namespace: 'features.iim_review.issue_card' })),
                React.createElement("div", { className: "signature-quality-card__context-row" },
                    React.createElement("i", { className: "fa-light fa-signature signature-quality-card__icon", "aria-hidden": "true" }),
                    React.createElement(Text, { variant: "x-small", as: "span", className: "signature-quality-card__type-label" }, signatureLabel)))),
            imageUrl && (React.createElement("div", { className: "signature-quality-card__image-frame" },
                React.createElement("img", { src: imageUrl, alt: signatureLabel !== null && signatureLabel !== void 0 ? signatureLabel : 'Signature', className: "signature-quality-card__image" }))),
            reason && (React.createElement("div", { className: "signature-quality-card__possible-issue" },
                React.createElement(Text, { variant: "xx-small", as: "p", className: "signature-quality-card__section-label" }, translate('possible_issue_label', { namespace: 'features.iim_review.issue_card' })),
                React.createElement(Text, { variant: "body", as: "p", className: "signature-quality-card__reason" }, reason))),
            confidencePct && (React.createElement("div", { className: "signature-quality-card__confidence-row" },
                React.createElement(Tag, { label: confidencePct, variant: "green", colorStyle: "pastry", readOnly: true }))))));
}
